<!-- eslint-disable @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/click-events-have-key-events -->
<header class="header">
    <mat-toolbar color="primary">
        <div class="header-detail-box">
            <button mat-icon-button class="burger-menu" [ngClass]="{ 'burger-menu-expand': !isExpanded }" (click)="sideNav()">
                <mat-icon>
                    {{ isExpanded ? 'menu' : 'close' }}
                </mat-icon>
            </button>
            <a class="logo-box" (click)="gotoDashboard()">
                <svg xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 148 14" role="img" aria-label="Sensesiant IoT core">
                    <text y="11" font-family="'IBM Plex Sans', sans-serif" font-size="11" fill="#161616" letter-spacing="0.3">Sensesiant</text>
                    <text x="76" y="11" font-family="'IBM Plex Sans', sans-serif" font-size="11" fill="#161616" letter-spacing="0.3">IoT core</text>
                </svg>
            </a>
            <div class="header-tab-btn-box desktop-view">
                <!-- <button type="button" class="header-tab-btn">Manage</button> -->
                <button type="button" class="header-tab-btn active">Monitor</button>
                <!-- <button type="button" class="header-tab-btn">Maintain</button> -->
            </div>
            <div class="header-dropdown-box mobile-view">
                <div class="form-group mat-form-field-width">
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Select">
                            @for (selectDropdown of selectDropdownList; track selectDropdown) {
                                <mat-option [value]="selectDropdown">
                                    {{ selectDropdown.value }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <span class="spacer"></span>
            <div class="header-icon-con desktop-view">
                <a href="javascript:void(0)" class="burger-menu">
                    <mat-icon [svgIcon]="'/assets/icons/header-icons/search-icon.svg' | svgToMatIcon"></mat-icon>
                </a>
                <a href="javascript:void(0)" class="burger-menu">
                    <mat-icon [svgIcon]="'/assets/icons/header-icons/help-icon.svg' | svgToMatIcon"></mat-icon>
                </a>
                <a href="javascript:void(0)" class="burger-menu">
                    <mat-icon [svgIcon]="'/assets/icons/header-icons/notification-icon.svg' | svgToMatIcon"></mat-icon>
                </a>
                <a href="javascript:void(0)" class="burger-menu">
                    <mat-icon [svgIcon]="'/assets/icons/header-icons/user-icon.svg' | svgToMatIcon"></mat-icon>
                </a>
                <a (click)="onLogout()" class="burger-menu">
                    <mat-icon [svgIcon]="'/assets/icons/header-icons/logout-icon.svg' | svgToMatIcon"></mat-icon>
                </a>
            </div>
            <div class="mobile-view">
                <a href="javascript:void(0)" class="burger-menu">
                    <mat-icon [svgIcon]="'/assets/icons/header-icons/notification-icon.svg' | svgToMatIcon"></mat-icon>
                </a>
                <a [matMenuTriggerFor]="userMenu" class="burger-menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
                    <mat-icon [svgIcon]="'/assets/icons/header-icons/user-icon.svg' | svgToMatIcon"></mat-icon>
                </a>

                <mat-menu class="user-profile-menu" #userMenu="matMenu" xPosition="before">
                    <a mat-menu-item>
                        <mat-icon [svgIcon]="'/assets/icons/header-icons/search-icon.svg' | svgToMatIcon"></mat-icon>
                        Search
                    </a>
                    <a mat-menu-item>
                        <mat-icon [svgIcon]="'/assets/icons/header-icons/help-icon.svg' | svgToMatIcon"></mat-icon>
                        Help
                    </a>
                    <a mat-menu-item (click)="onLogout()">
                        <mat-icon [svgIcon]="'/assets/icons/header-icons/logout-icon.svg' | svgToMatIcon"></mat-icon>
                        Log Out
                    </a>
                </mat-menu>
            </div>
        </div>
    </mat-toolbar>
</header>
